<template>
    <ModalComponent
        :name="'anular-' + abonado.id"
        :title="'Devolver abono de ' + abonado.name + ' ' + abonado.surnames"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <h2>Datos del abonado</h2>
            </div>
            <div class="col-12">
                <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                        <b>Nª de abonado:</b> <a>{{ abonado.n_abonado }}</a>
                    </li>
                    <li class="list-group-item">
                        <b>Nombre:</b> <a>{{ abonado.name }}</a>
                    </li>
                    <li class="list-group-item">
                        <b>Apellidos:</b> <a>{{ abonado.surnames }}</a>
                    </li>
                    <li class="list-group-item">
                        <b>DNI:</b> <a>{{ abonado.dni }}</a>
                    </li>
                    <li class="list-group-item">
                        <b>Email:</b> <a>{{ abonado.email }}</a>
                    </li>
                    <li class="list-group-item">
                        <b>Asiento: </b>
                        <a>
                            <template v-if="abonado.tiene_asiento || abonado.plaza">
                                <span v-if="abonado.tiene_asiento">Zona: {{ abonado.asiento.region }}, Fila: {{ abonado.asiento.row }}, Butaca: {{ abonado.asiento.seat }}</span>
                                <span v-if="abonado.plaza">{{ abonado.plaza.region_name + ', ' ?? '' }}Fila: {{ abonado.plaza.fila }}, Butaca: {{ abonado.plaza.butaca }}</span>
                            </template>
                            <template v-else>
                                Sin asiento
                            </template>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-12 text-center" v-if="!anulado">
                <h1 class="font-weight-bold">¿ANULAR ABONO?</h1>
            </div>
            <div class="col-12 text-center" v-if="!anulado">
                <Button :disabled="disableButton" type="button" name="button" @click.prevent="anularAbonado">SI, ANULAR</Button>
            </div>
            <div class="col-12" v-if="anulado">
                <h1 class="font-weight-bold">ANULADO</h1>
            </div>
        </div>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['abonado'],
        data() {
            return {
                anulado: false,
                url: null,
                disableButton: false
            }
        },
        methods: {
            close() {
                this.$emit('close', 'anular-' + this.abonado.id, this.anulado);
            },
            anularAbonado() {
                const params = {
                    filters : {},
                    abonado_id: this.abonado.id
                };

                this.disableButton = true;

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.anular'), params).then(res => {
                    this.anulado = true;
                    this.$toast.success("Abonado anulado");
                }).catch(() => {
                    this.disableButton = false;
                });
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
